import {Stack, CheckboxGroup, HStack, Checkbox, Tag, Text, Icon} from "@chakra-ui/react";
import {DocumentExternal, DocumentId} from "../../../Types";
import {DOCUMENT_CATEGORY_MAP} from "../../../Products/VendorToolkit/components/DocumentCategory";
import {ExclamationCircleIcon} from "@heroicons/react/20/solid";
import React from "react";

type DocumentSelectorProps = {
  documents: DocumentExternal[];
  value: DocumentId[];
  onChange: (value: DocumentId[]) => void;
};

function RestrictedDocumentSelector({documents, value, onChange}: DocumentSelectorProps) {
  return (
    <Stack border="1px solid" borderColor="gray.200" rounded="md" flex="1" spacing={0} overflow="hidden" bg="gray.50">
      <CheckboxGroup value={value} onChange={v => onChange(v as DocumentId[])}>
        <Stack p={0} spacing={0} flex="1">
          {Object.entries(DOCUMENT_CATEGORY_MAP).map(([c, i]) => {
            const filteredDocuments = documents.filter(d => d.category === c);

            return filteredDocuments.length > 0 ? (
              <React.Fragment key={c}>
                <HStack p={2} px={4} borderBottom="1px solid" borderColor="gray.200" bg="blue.500" color="white">
                  <Text fontSize="md" fontWeight="500">
                    {i.textPlural}
                  </Text>
                </HStack>
                {filteredDocuments.map(d => (
                  <Checkbox
                    key={d.document_id}
                    value={d.document_id}
                    borderBottom="1px solid"
                    borderColor="gray.200"
                    px={4}
                    py={3}
                    spacing={4}
                    // Style the inner label
                    sx={{"& > :last-child": {flex: "1"}}}
                    _hover={{bg: "gray.50"}}
                    _active={{bg: "gray.100"}}
                    alignSelf="stretch"
                    bg="white"
                  >
                    <HStack justifyContent="space-between">
                      <Text>{d.name}</Text>
                      {d.requires_esignature && <Tag colorScheme="blue">Requires NDA</Tag>}
                    </HStack>
                  </Checkbox>
                ))}
              </React.Fragment>
            ) : null;
          })}
        </Stack>
      </CheckboxGroup>
      {value.length === 0 && (
        <HStack p={2} px={4} spacing={4} bg="red.100" color="red.800" fontSize="md">
          <Icon as={ExclamationCircleIcon} />
          <Text>Please select at least one document.</Text>
        </HStack>
      )}
    </Stack>
  );
}

export default RestrictedDocumentSelector;
